'use client';
import { Box, List, ListItem, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonContainer from '@components/CommonContainer';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import cn from './style.module.scss';

export default function LsqSodicExclusive(props: MarketingPageComponentProps) {
  const exclusiveSection = props?.locale?.section?.find(
    (section: any) => section.type === 'exclusive' && section.enabled
  );
  if (!exclusiveSection) return null;
  const contentItems: string[] =
    exclusiveSection?.lsqSodicExclusiveContent ?? [];

  return (
    <Stack component="section" className={cn.sodicExclusiveWrapper}>
      <Box
        className={cn.sodicExclusiveInner}
        sx={{
          backgroundImage: `url(${exclusiveSection?.lsqSodicExclusiveBackground})`,
        }}
      >
        <CommonContainer
          paddingInline={{ xs: '1.25rem' }}
          maxWidth={{ sm: '100%', md: '1180px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.sodicExclusiveBlock}>
            <Box className={cn.sodicExclusiveContent}>
              <Box className={cn.sodicExclusiveLabel}>
                <ParallaxText
                  variant="h4"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(exclusiveSection?.lsqSodicExclusiveLabel)}
                </ParallaxText>
              </Box>
              <Box className={cn.sodicExclusiveHeading}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(exclusiveSection?.lsqSodicExclusiveHeading)}
                </ParallaxText>
              </Box>
              <List className={cn.sodicExclusiveList}>
                {contentItems.map((item: string, index: number) => (
                  <ListItem
                    key={index}
                    className={cn.sodicExclusiveItem}
                    {...mergeAos(fadeUpAosProps, getAosDelay(index * 100))}
                  >
                    <ParallaxText
                      variant="p"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(item)}
                    </ParallaxText>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
